import { BORDERS, COLOR, CORNERS } from 'vars/index'

export const LABEL_PADDINGS = {
  SIZE_10: '--label-paddings-size-10', // Paid label
  SIZE_20: '--label-paddings-size-20', // Rented label
  SIZE_30: '--label-paddings-size-30', // Rented label episode
  SIZE_40: '--label-paddings-size-40', // Paid label episode
  SIZE_50: '--label-paddings-size-50', // Rented details label
} as const
export type LABEL_PADDINGS =
  (typeof LABEL_PADDINGS)[keyof typeof LABEL_PADDINGS]

export const Corners = {
  CORNERS_0: CORNERS.CORNERS_0,
  CORNERS_5: CORNERS.CORNERS_5,
  CORNERS_10: CORNERS.CORNERS_10,
  CORNERS_20: CORNERS.CORNERS_20,
  CORNERS_30: CORNERS.CORNERS_30,
  CORNERS_50: CORNERS.CORNERS_50,
  CORNERS_LEFT_10: CORNERS.CORNERS_LEFT_10,
  CORNERS_RIGHT_10: CORNERS.CORNERS_RIGHT_10,
  CORNERS_RIGHT_BOTTOM_25: CORNERS.CORNERS_RIGHT_BOTTOM_25,
} as const
export type Corners = (typeof Corners)[keyof typeof Corners]

export const LabelsOrder = {
  ORDER_1: 0,
  ORDER_2: 1,
  ORDER_3: 2,
  ORDER_4: 3,
} as const
export type LabelsOrder = (typeof LabelsOrder)[keyof typeof LabelsOrder]

export const Borders = {
  BORDER_0: BORDERS.BORDER_0,
  BORDER_10: BORDERS.BORDER_10,
  BORDER_20: BORDERS.BORDER_20,
  BORDER_30: BORDERS.BORDER_30,
} as const
export type Borders = (typeof Borders)[keyof typeof Borders]

export const Backgrounds = {
  TEXT_ICON_PRIMARY: COLOR.TEXT_ICON_PRIMARY,
  ACCENT_PRIMARY_GRADIENT: COLOR.ACCENT_PRIMARY_GRADIENT,
  SURFACE_OPACITY_LIGHT_10: COLOR.SURFACE_OPACITY_LIGHT_10,
  ADDITIONAL_RED_2: COLOR.ADDITIONAL_RED_2,
  ADDITIONAL_RED_3: COLOR.ADDITIONAL_RED_3,
  SURFACE_OPACITY_DARK_40: COLOR.SURFACE_OPACITY_DARK_40,
  SURFACE_OPACITY_DARK_60: COLOR.SURFACE_OPACITY_DARK_60,
  ADDITIONAL_ORANGE_3: COLOR.ADDITIONAL_ORANGE_3,
  ACCENT_SECONDARY: COLOR.ACCENT_SECONDARY,
  ACCENT_TERTIARY: COLOR.ACCENT_TERTIARY,
  SURFACE_DARK_7: COLOR.SURFACE_DARK_7,
  ADDITIONAL_BLUE_2: COLOR.ADDITIONAL_BLUE_2,
  SUBTITLE_BLUE: COLOR.SUBTITLE_BLUE,
} as const
export type Backgrounds = (typeof Backgrounds)[keyof typeof Backgrounds]

export const Colors = {
  TEXT_ICON_SECONDARY: COLOR.TEXT_ICON_SECONDARY,
} as const
export type Colors = (typeof Colors)[keyof typeof Colors]

export const BorderColors = {
  ACCENT_TERTIARY: COLOR.ACCENT_TERTIARY,
  TEXT_ICON_SECONDARY: COLOR.TEXT_ICON_SECONDARY,
} as const
export type BorderColors = (typeof BorderColors)[keyof typeof BorderColors]

export const Fonts = {
  Caption1: 'Caption1',
  Caption3: 'Caption3',
  Caption4: 'Caption4',
  Caption5: 'Caption5',
  Body4: 'Body4',
  Footnote5: 'Footnote5',
  FontSm: 'FontSm',
  FontMdToSm: 'FontMdToSm',
  FontMdToSmBold: 'FontMdToSmBold',
  FontXs: 'FontXs',
  FontXsBold: 'FontXsBold',
  FontSmBold: 'FontSmBold',
} as const
export type Fonts = (typeof Fonts)[keyof typeof Fonts]

type PaddingKey =
  | 'SIZE_10'
  | 'SIZE_20'
  | 'SIZE_30'
  | 'SIZE_40'
  | 'SIZE_50'
  | 'SIZE_60'
  | 'SIZE_70'
  | 'SIZE_80'
  | 'SIZE_90'
  | 'SIZE_100'
export const Paddings: Record<
  PaddingKey,
  readonly [string, string, string, string]
> = {
  SIZE_10: [
    '0.125em',
    '0.5em',
    '0.125em',
    '0.5em',
    // INDENTS.INDENT_5,
    // INDENTS.INDENT_20,
    // INDENTS.INDENT_5,
    // INDENTS.INDENT_20,
  ],
  SIZE_20: [
    '0.25em',
    '0.75em',
    '0.25em',
    '0.75em',
    // INDENTS.INDENT_10,
    // INDENTS.INDENT_40,
    // INDENTS.INDENT_10,
    // INDENTS.INDENT_40,
  ],
  SIZE_30: ['0.25em', '1em', '0.25em', '1em'],
  SIZE_40: ['0.125em', '0.625em', '0.125em', '0.625em'],
  SIZE_50: ['0.125em', '0.375em', '0.125em', '0.375em'],
  SIZE_60: ['0.25em', '0.625em', '0.25em', '0.625em'],
  SIZE_70: ['0', '0.5rem', '0', '0.5rem'],
  SIZE_80: ['0.25rem', '0.25rem', '0.25rem', '0.25rem'],
  SIZE_90: ['0.125rem', '0.5rem', '0.125rem', '0.5rem'],
  SIZE_100: ['0.25rem', '0.5rem', '0.25rem', '0.5rem'],
} as const
export type Padding = (typeof Paddings)[keyof typeof Paddings]
